import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];
    
    // サポートされている言語コードのリスト
    const supportedLanguages = [
      'en', 'ja', 'zh', 'de', 'fr', 'it', 'th', 'nl', 'id', 'el', 
      'ko', 'hi', 'sv', 'pl', 'es', 'ru', 'pt', 'tr', 'vi', 'ta', 
      'fa', 'tl', 'ar', 'uk'
    ];

    // 最初のセグメントが言語コードかチェック
    if (firstSegment && supportedLanguages.includes(firstSegment)) {
      // 言語コードがURLに含まれている場合、i18nの言語を設定
      if (i18n.language !== firstSegment) {
        i18n.changeLanguage(firstSegment);
      }
    } else if (location.pathname !== '/') {
      // 言語コードがURLに含まれていない場合、デフォルト言語（英語）にリダイレクト
      const currentPath = location.pathname + location.search;
      navigate(`/en${currentPath}`);
    }
  }, [location.pathname, location.search, i18n, navigate]);

  return <>{children}</>;
};

export default LanguageWrapper; 